<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import SidenavItem from "./SidenavItem.vue";
const store = useStore();
const isRTL = computed(() => store.state.isRTL);

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};
</script>
<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          to="/Dashboard"
          :class="getRoute() === 'Dashboard' ? 'active' : ''"
          :navText="'Mesa de Trabajo'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
<!-- 
      <li class="nav-item">
        <sidenav-item
          to="/salidaProductos"
          :class="getRoute() === 'salida' ? 'active' : ''"
          :navText="'Salida de Productos'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li> -->

      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'"
        >
          MOVIMIENTOS
        </h6>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/entrada"
          :class="getRoute() === 'entrada' ? 'active' : ''"
          :navText="isRTL ? 'Entrada' : 'Entrada'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'"
        >
          ADMINISTRACION
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-item
          to="/usuarios"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="isRTL ? 'Usuarios' : 'Usuarios'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/productos"
          :class="getRoute() === 'productos' ? 'active' : ''"
          :navText="'Productos'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/stores"
          :class="getRoute() === 'stores' ? 'active' : ''"
          :navText="'Tiendas'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
</template>
